import { render, staticRenderFns } from "./CollectionCover.vue?vue&type=template&id=b205f95e&scoped=true"
import script from "./CollectionCover.vue?vue&type=script&lang=js"
export * from "./CollectionCover.vue?vue&type=script&lang=js"
import style0 from "./CollectionCover.vue?vue&type=style&index=0&id=b205f95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b205f95e",
  null
  
)

export default component.exports